import "./EditService.scss";
import { BackButton } from "../../../../../components/primaryComponents";
import secondaryComponents from "../../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import { useEditService } from "./useEditService";
import { ServiceForm } from "../../../../../components/secondaryComponents/products";

const EditService = () => {
  const { isFetchingService, serviceDetails } = useEditService();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Service"
      description="Edit service details"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <div>
            <BackButton />
          </div>

          <div className="edit-single-product-page__content">
            <div className="edit-single-product-page__content-heeader">
              <h3 className="font-weight-semibold">Edit Service</h3>
              <p>Please provide the following information about your service</p>
            </div>

            <secondaryComponents.LoaderHelper
              isLoading={isFetchingService}
              classNames="mt-5"
            >
              <ServiceForm isEditMode={true} productDetails={serviceDetails} />
            </secondaryComponents.LoaderHelper>
          </div>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};

export default EditService;
